//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ScheduleOrientationSessionTypesEnum } from './enums/schedule-orientation-session-types-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AddScheduleOrientationSessionDto } from './models/add-schedule-orientation-session-dto.model';
import { CandidateAvailabilityDateDto } from './models/candidate-availability-date-dto.model';
import { FetchArguments2OfPerDiemScheduleOrientationFilter } from './models/fetch-arguments2of-per-diem-schedule-orientation-filter.model';
import { MultiBundleStatus } from './models/multi-bundle-status.model';
import { PagingTokenOfScheduleOrientationDto } from './models/paging-token-of-schedule-orientation-dto.model';
import { ScheduleOrientationDto } from './models/schedule-orientation-dto.model';
import { ScheduleOrientationPresetDateDto } from './models/schedule-orientation-preset-date-dto.model';
import { ScheduleOrientationSessionTypeDto } from './models/schedule-orientation-session-type-dto.model';
import { UpdateOrientationDto } from './models/update-orientation-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ScheduleOrientationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOrientation(contractId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrientation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrientation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processGetOrientation(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrientationPOST(contractId: number, note: string): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrientationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrientationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processScheduleOrientationPOST(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrientationDELETE(contractId: number): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrientationDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrientationDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleOrientationDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrientationByScheduleOrientationId(scheduleOrientationId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/ByScheduleOrientationId/{scheduleOrientationId}";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrientationByScheduleOrientationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrientationByScheduleOrientationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processGetOrientationByScheduleOrientationId(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrientations(contractId: number, args: FetchArguments2OfPerDiemScheduleOrientationFilter): Observable<PagingTokenOfScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/sessions";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrientations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrientations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfScheduleOrientationDto>;
        }));
    }

    protected processGetOrientations(response: HttpResponseBase): Observable<PagingTokenOfScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActionRequiredOrientationSessionsCount(contractId: number): Observable<number> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/actionRequiredOrientationSessionsCount";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActionRequiredOrientationSessionsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionRequiredOrientationSessionsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActionRequiredOrientationSessionsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    askForNewAvailability(scheduleOrientationId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/AskForNewAvailability";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskForNewAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskForNewAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processAskForNewAvailability(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rescheduleOrientation(scheduleOrientationId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/RescheduleOrientation";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleOrientation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleOrientation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processRescheduleOrientation(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrientationSession(contractId: number, scheduleOrientationSessionsDto: AddScheduleOrientationSessionDto[]): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/Session";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleOrientationSessionsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrientationSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrientationSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleOrientationSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrientationDatePUT(dateId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{dateId}/ScheduleOrientationDate";
        if (dateId === undefined || dateId === null)
            throw new Error("The parameter 'dateId' must be defined.");
        url_ = url_.replace("{dateId}", encodeURIComponent("" + dateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrientationDatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrientationDatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processScheduleOrientationDatePUT(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrientationDatePOST(scheduleOrientationId: number, date: Date): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/ScheduleOrientationDate";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(date);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrientationDatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrientationDatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processScheduleOrientationDatePOST(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelScheduleOrientation(scheduleOrientationId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/Cancel";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelScheduleOrientation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelScheduleOrientation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processCancelScheduleOrientation(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityScheduleOrientationPermission(facilityId: number): Observable<number | null> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{facilityId}/permission";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityScheduleOrientationPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityScheduleOrientationPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetFacilityScheduleOrientationPermission(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScheduleOrientationSessionTypes(): Observable<ScheduleOrientationSessionTypeDto[]> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/ScheduleOrientationSessionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleOrientationSessionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleOrientationSessionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationSessionTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationSessionTypeDto[]>;
        }));
    }

    protected processGetScheduleOrientationSessionTypes(response: HttpResponseBase): Observable<ScheduleOrientationSessionTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationSessionTypeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNote(scheduleOrientationId: number, note: string): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/UpdateNote";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendOrientationToMyAya(scheduleOrientationId: number): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/SendOrientationToMyAya";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOrientationToMyAya(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrientationToMyAya(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processSendOrientationToMyAya(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextDayForSessionType(contractId: number, sessionTypeId: ScheduleOrientationSessionTypesEnum): Observable<number> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/{sessionTypeId}/GetNextDayForSessionType";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (sessionTypeId === undefined || sessionTypeId === null)
            throw new Error("The parameter 'sessionTypeId' must be defined.");
        url_ = url_.replace("{sessionTypeId}", encodeURIComponent("" + sessionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextDayForSessionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextDayForSessionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNextDayForSessionType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    doesAnyOrientationExist(contractId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/DoesAnyOrientationExist";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesAnyOrientationExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesAnyOrientationExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesAnyOrientationExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMultiBundlesStatuses(contractId: number): Observable<MultiBundleStatus[]> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/GetMultiBundlesStatuses";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultiBundlesStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultiBundlesStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultiBundleStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultiBundleStatus[]>;
        }));
    }

    protected processGetMultiBundlesStatuses(response: HttpResponseBase): Observable<MultiBundleStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultiBundleStatus[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOrientationAvailability(orientationDto: UpdateOrientationDto): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/UpdateOrientationAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orientationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrientationAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrientationAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processUpdateOrientationAvailability(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleMultiDayOrientations(firstDayOrientationId: number, candidateAvailabilityDates: CandidateAvailabilityDateDto[]): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{firstDayOrientationId}/ScheduleMultiDayOrientations";
        if (firstDayOrientationId === undefined || firstDayOrientationId === null)
            throw new Error("The parameter 'firstDayOrientationId' must be defined.");
        url_ = url_.replace("{firstDayOrientationId}", encodeURIComponent("" + firstDayOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidateAvailabilityDates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleMultiDayOrientations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleMultiDayOrientations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processScheduleMultiDayOrientations(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    multiDayAskForNewAvailability(firstDayOrientationId: number, listOforientationDto: UpdateOrientationDto[]): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{firstDayOrientationId}/MultiDayAskForNewAvailability";
        if (firstDayOrientationId === undefined || firstDayOrientationId === null)
            throw new Error("The parameter 'firstDayOrientationId' must be defined.");
        url_ = url_.replace("{firstDayOrientationId}", encodeURIComponent("" + firstDayOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listOforientationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultiDayAskForNewAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultiDayAskForNewAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processMultiDayAskForNewAvailability(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNoteOfOrientation(scheduleOrientationId: number, note: string): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{scheduleOrientationId}/UpdateNoteOfOrientation";
        if (scheduleOrientationId === undefined || scheduleOrientationId === null)
            throw new Error("The parameter 'scheduleOrientationId' must be defined.");
        url_ = url_.replace("{scheduleOrientationId}", encodeURIComponent("" + scheduleOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNoteOfOrientation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNoteOfOrientation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processUpdateNoteOfOrientation(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePresetDatesOfOrientation(orientationPresetDateDto: ScheduleOrientationPresetDateDto): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/UpdatePresetDatesOfOrientation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orientationPresetDateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePresetDatesOfOrientation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePresetDatesOfOrientation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processUpdatePresetDatesOfOrientation(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingOrientationForSessionType(contractId: number, sessionTypeId: ScheduleOrientationSessionTypesEnum): Observable<ScheduleOrientationDto[]> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{contractId}/{sessionTypeId}/GetExistingOrientationForSessionType";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (sessionTypeId === undefined || sessionTypeId === null)
            throw new Error("The parameter 'sessionTypeId' must be defined.");
        url_ = url_.replace("{sessionTypeId}", encodeURIComponent("" + sessionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingOrientationForSessionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingOrientationForSessionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto[]>;
        }));
    }

    protected processGetExistingOrientationForSessionType(response: HttpResponseBase): Observable<ScheduleOrientationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rescheduleMultiDayOrientations(firstDayOrientationId: number, listOfOrientationIds: number[]): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{firstDayOrientationId}/RescheduleMultiDayOrientations";
        if (firstDayOrientationId === undefined || firstDayOrientationId === null)
            throw new Error("The parameter 'firstDayOrientationId' must be defined.");
        url_ = url_.replace("{firstDayOrientationId}", encodeURIComponent("" + firstDayOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listOfOrientationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleMultiDayOrientations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleMultiDayOrientations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processRescheduleMultiDayOrientations(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendMultiDayOrientationToMyAya(firstDayOrientationId: number, listOfOrientationIds: number[]): Observable<ScheduleOrientationDto> {
        let url_ = this.baseUrl + "/AyaNova/ScheduleOrientation/{firstDayOrientationId}/SendMultiDayOrientationToMyAya";
        if (firstDayOrientationId === undefined || firstDayOrientationId === null)
            throw new Error("The parameter 'firstDayOrientationId' must be defined.");
        url_ = url_.replace("{firstDayOrientationId}", encodeURIComponent("" + firstDayOrientationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listOfOrientationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMultiDayOrientationToMyAya(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMultiDayOrientationToMyAya(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOrientationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOrientationDto>;
        }));
    }

    protected processSendMultiDayOrientationToMyAya(response: HttpResponseBase): Observable<ScheduleOrientationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleOrientationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}